import React from 'react';
import ExcelJS from 'exceljs';
import { CButton } from '@coreui/react';

function DownloadExcel(props) {
    const handlerClickDownloadButton = async () => {
        // Create workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        workbook.addWorksheet('sheet1', {
            headerFooter: {
                firstHeader: 'Hello Exceljs',
                firstFooter: 'Hello World'
            }
        });

        const worksheet = workbook.getWorksheet('sheet1');
        const config = props.config ? props.config : { width: '30' };

        // Convert column letters to indices (A=1, B=2, C=3, etc.)
        const dateFormatCols = props.dateFormat 
            ? props.dateFormat.map(col => col.toUpperCase().charCodeAt(0) - 64)
            : [];

        // Set up columns with date formatting where needed
        worksheet.columns = [
            { header: 'No', key: 'no', width: '5' },
            ...props.columns.map((item, index) => {
                const columnIndex = index + 2; // +2 because 'No' is column 1
                const isDateColumn = dateFormatCols.includes(columnIndex);
                
                return {
                    header: item.headerName,
                    key: item.field,
                    ...config,
                    ...(isDateColumn && { 
                        style: { 
                            numFmt: 'dd/mm/yyyy',
                            // Additional date styling can go here
                        } 
                    })
                };
            })
        ];

        // Add extra header row if provided
        if (props.extra) {
            worksheet.addRow(props.extra);
        }

        // Add conditional formatting if provided
        if (props.conditional) {
            worksheet.addConditionalFormatting(props.conditional);
        }

        if (props.border) {
            worksheet.addConditionalFormatting(props.border);
        }

        // Add empty row if needed
        if (props.showTotalRow !== false) { // Default to showing unless explicitly false
            worksheet.addRow({
                Total: '',
                Amount: ''
            });
        }

        // Process and add data rows
        const data = props.rows || [];
        data.forEach((item, i) => {
            const rowData = { no: i + 1 };
            
            // Convert date strings to Date objects for date-formatted columns
            Object.keys(item).forEach(key => {
                const colIndex = props.columns.findIndex(col => col.field === key) + 2;
                if (dateFormatCols.includes(colIndex) && item[key]) {
                    // Try to parse the date string
                    const dateValue = new Date(item[key]);
                    rowData[key] = isNaN(dateValue.getTime()) ? item[key] : dateValue;
                } else {
                    rowData[key] = item[key];
                }
            });
            
            const addedRow = worksheet.addRow(rowData);
            
            // Ensure date formatting is applied (in case the style wasn't picked up)
            dateFormatCols.forEach(colIndex => {
                const cell = addedRow.getCell(colIndex);
                if (cell.value instanceof Date) {
                    cell.numFmt = 'yyyy/mm/dd';
                }
            });
        });

        // Auto-fit columns for better display
        worksheet.columns.forEach(column => {
            if (column.values) {
                const lengths = column.values.map(v => v ? v.toString().length : 0);
                const maxLength = Math.max(...lengths.filter(v => typeof v === 'number'));
                column.width = maxLength < 10 ? 10 : maxLength + 2;
            }
        });

        // Generate and download the file
        const uint8Array = await workbook.xlsx.writeBuffer();
        const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        const fileName = props.excelName 
            ? `${props.excelName} ${props.dateFrom || ''} sampai ${props.dateTo || ''}.xlsx`
            : 'export.xlsx';
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    return (
        <CButton
            disabled={props.loading || !props.rows || props.rows.length === 0}
            onClick={handlerClickDownloadButton}
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
        >
            {props.loading ? 'Generating...' : 'Download Excel'}
        </CButton>
    );
}

DownloadExcel.defaultProps = {
    config: { width: 30 },
    dateFormat: [],
    showTotalRow: true,
    loading: false
};

export default DownloadExcel;